/**
 * Initializes the scroll-to-top button functionality.
 */
export const initScrollToTopButton = (): void => {
  const button = document.querySelector<HTMLButtonElement>(".scroll-to-top");

  if (!button) {
    return; // Silently exit if the button isn't on the page
  }

  const scrollThreshold = 400; // Show button after scrolling 400px

  const toggleVisibility = () => {
    if (window.scrollY > scrollThreshold) {
      button.classList.add("is-visible");
    } else {
      button.classList.remove("is-visible");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Check visibility on page load/refresh
  toggleVisibility();

  // Add event listeners
  window.addEventListener("scroll", toggleVisibility, { passive: true });
  button.addEventListener("click", scrollToTop);

  console.log("[Footer] Scroll-to-top button initialized.");
};
